import React, { useState, useEffect } from 'react';
import { Share2 } from 'lucide-react';
import { Button } from './ui/button';
import { useAuth, useLanguage, api } from '../context/AppContext';
import { StreakFlame } from './StreakFlame';
import StreakShareModal from './StreakShareModal';

export default function StreakShareButton({ variant = 'inline', className = '' }) {
  const { user } = useAuth();
  const { language } = useLanguage();
  const fr = language === 'fr';
  const [streak, setStreak] = useState(0);
  const [gradeId, setGradeId] = useState('recrue');
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    if (!user) return;
    api.get('/workouts/streak').then(r => setStreak(r.data.streak || 0)).catch(() => {});
    api.get('/leaderboard/my-stats').then(r => {
      setGradeId(r.data.grade?.id || 'recrue');
    }).catch(() => {});
  }, [user]);

  if (streak <= 0) return null;

  const displayName = user?.warrior_name || user?.name || '';

  if (variant === 'compact') {
    return (
      <>
        <button
          onClick={() => setShowModal(true)}
          className={`inline-flex items-center gap-1.5 px-2.5 py-1.5 rounded-lg bg-orange-500/10 border border-orange-500/20 hover:bg-orange-500/20 transition-colors ${className}`}
          data-testid="streak-share-compact-btn"
        >
          <StreakFlame streak={streak} size="xs" />
          <span className="text-xs font-bold text-orange-400">{streak}j</span>
          <Share2 className="w-3 h-3 text-orange-400/60" />
        </button>
        {showModal && (
          <StreakShareModal
            streak={streak}
            gradeId={gradeId}
            userName={displayName}
            language={language}
            onClose={() => setShowModal(false)}
          />
        )}
      </>
    );
  }

  return (
    <>
      <Button
        onClick={() => setShowModal(true)}
        variant="outline"
        className={`border-orange-500/30 text-orange-400 hover:bg-orange-500/10 gap-2 ${className}`}
        data-testid="streak-share-inline-btn"
      >
        <StreakFlame streak={streak} size="xs" />
        <span className="font-heading text-xs uppercase tracking-wider">
          {streak} {fr ? 'jours' : 'days'}
        </span>
        <Share2 className="w-3.5 h-3.5" />
      </Button>
      {showModal && (
        <StreakShareModal
          streak={streak}
          gradeId={gradeId}
          userName={displayName}
          language={language}
          onClose={() => setShowModal(false)}
        />
      )}
    </>
  );
}
